import * as React from 'react'
import { MenuItem, MenuItemProps } from '../MenuItem/MenuItem'
import { ComponentProps } from 'react'

export type MenuItemsArray = ComponentProps<typeof VerticalMenu>['menuItems']

type VerticalMenuProps = React.PropsWithChildren & {
    menuItems: Array<
        Omit<MenuItemProps, 'variant' | 'hideLabel'> & {
            id: string
            isHidden?: boolean
            walkthroughId?: string
        }
    >
    menuItemClassName?: string
    menuItemLabelWrapperClassname?: string
} & Pick<MenuItemProps, 'variant' | 'hideLabel' | 'render'>

export const VerticalMenu: React.FC<VerticalMenuProps> = ({
    menuItems,
    variant,
    hideLabel,
    render,
    menuItemClassName,
    menuItemLabelWrapperClassname,
}) => {
    return menuItems
        .filter((item) => !item.isHidden)
        .map((item) => {
            return (
                <div key={item.id} data-walkthrough={item.walkthroughId}>
                    <MenuItem
                        {...item}
                        variant={variant}
                        hideLabel={hideLabel}
                        render={item.render ?? render}
                        className={menuItemClassName}
                        labelWrapperClassname={menuItemLabelWrapperClassname}
                    />
                </div>
            )
        })
}
